module.exports = ".workflow-logs-viewer .log-box{white-space:pre;font-family:monospace;overflow:scroll;min-height:500px;max-height:800px}"